import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { DncLog, fmt } from "./_types";

interface Props {
  dnc_logs: DncLog[];
}

export default function ActivityTab({ dnc_logs }: Props) {
  return (
    <div className="space-y-3">
      {dnc_logs.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-16">No activity recorded yet.</p>
      ) : (
        <Card>
          <CardHeader><CardTitle className="text-base">DNC Check History</CardTitle></CardHeader>
          <CardContent>
            <ul className="space-y-2">
              {dnc_logs.map((log, i) => (
                <li key={i} className="text-xs border-b border-gray-100 pb-2 last:border-0">
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${log.result === "clear" ? "text-green-600" : "text-red-600"}`}>
                      {log.result}
                    </span>
                    <span className="text-gray-400">{log.layer}</span>
                  </div>
                  <div className="text-gray-400 mt-0.5">{fmt(log.checked_at)}</div>
                  {log.notes && <div className="text-gray-500 mt-0.5">{log.notes}</div>}
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
